<template>
    <div class="index-page">
        <PageTopBar></PageTopBar>
        <pageHeaderBar></pageHeaderBar>
        <SideBar></SideBar>
        <MenuBar></MenuBar>
        <div class="grey-body">
            <div class="list-bread">
                <a :href="webRoot">首页</a>
                <span>></span>
                <a>就近预约</a>
            </div>
            <div class="list-body shop-list">
                <div class="search-area">
                    <ul>
                        <li class="more-list" id="clinic-area">
                            <span class="area-txt">区&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;域：</span>
                            <div class="search-list list limited dist">
                                <label :class="returnClassName(index, item.isSelected)" :data-index="index" :title="item.name"
                                       v-for="(item, index) in districtList"
                                       @click="getNewDist(index, item.areaId,item.isSelected)"><p>{{item.name}}</p>
                                </label>
                                <div class="de-more" v-if="districtList.length > 10" @click="areaMore">
                                    更多
                                    <div class="triangle triangle-down" id="area-triangle"></div>
                                </div>
                            </div>
                        </li>
                        <li class="more-list" id="clinic-depart">
                            <span class="area-txt">科&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;室：</span>
                            <div class="search-list list limited">
                                <label :class="returnClassName(index, item.isSelected)" :data-index="index" :title="item.departmentName"
                                       v-for="(item, index) in departmentsList" @click="getNewDep(index, item.isSelected)"><p>
                                    {{item.departmentName}}</p></label>
                                <div class="de-more" v-if="departmentsList.length > 10" @click="departMore">
                                    更多
                                    <div class="triangle triangle-down" id="depart-triangle"></div>
                                </div>
                            </div>
                        </li>
                        <li>
                            <span class="area-txt">医院资质：</span>
                            <div class="search-list list limited">
                                <label :class="returnClassName(index, item.isSelected)" :data-index="index" :title="item.name"
                                       v-for="(item, index) in hospitalQualification" @click="getNewHospital(index, item.isSelected)">
                                    <p>{{item.name}}</p></label>
                            </div>
                        </li>
                    </ul>
                </div>
                <LoadingBar height="120px" v-if="searchLoading"></LoadingBar>
                <div class="list-content clearfix" id="list-box" v-if="listShow">
                    <div class="list-left recommed-doctor">

                            <div class="clinic-list">
                                <template v-if="clinicListData.length>0" v-for="(item, index) in clinicListData">
                                    <div class="clinic-groom clearfix">
                                        <a :href="appointmentImm(item.id)" class="doc-portrait">
                                            <img class="doc-img"  :src="returnImgPath(item.clinicFacadeName, nginxRoot, 'middle')" alt="" :onerror="defaultClinicImg">
                                        </a>
                                        <div class="doc-list">
                                            <ul>
                                                <li>
                                                    <h1><a :href="appointmentImm(item.id)">{{item.clinicName}}</a></h1>
                                                </li>
                                                <li class="shop-certification">
                                                    <span style="border: 1px solid #259be2; color: #259be2;" v-if="item.unionFlag== '1'">联盟</span>
                                                    <span style="border: 1px solid #fd8e24; color: #fd8e24;"
                                                          v-if="item.auditResult == '02' || item.auditResult == '11' || item.auditResult == '15'">三星认证</span>
                                                    <span style="border: 1px solid #fd8e24; color: #fd8e24;"
                                                          v-else-if="item.auditResult == '04'">四星认证</span>
                                                    <span style="border: 1px solid #fd8e24; color: #fd8e24;"
                                                          v-else-if="item.auditResult == '05'">五星认证</span>
                                                    <span style="border: 1px solid #3ebc77; color: #3ebc77;" v-if="item.isMedicalInsurance == '1'">医保</span>
                                                    <span style="border: 1px solid #bc00ae; color: #bc00ae;" v-if="item.isCommercialInsurance == '1'">商保</span>
                                                </li>
                                                <li>
                                                    <p style="overflow: hidden;white-space: nowrap;text-overflow:ellipsis;"><span>科&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;室：</span><span>{{item.diagnosisType1}}</span></p>
                                                </li>

                                                <li>
                                                    <p style="overflow: hidden;white-space: nowrap;text-overflow:ellipsis;">地&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;址：{{item.address}}</p>
                                                </li>
                                                <li v-if="item.prdNames">
                                                    <p style="overflow: hidden;white-space: nowrap;text-overflow:ellipsis;"><span>健康商品：</span><span>{{item.prdNames}}</span></p>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="operating">
                                            <div class="btn-follow" @click="unfollowFun(item.id,index)" v-if="item.isConcern == '1'">
                                                <span class="follow"></span><em>已关注</em>
                                            </div>
                                            <div v-else  class="btn-follow" @click="followFun(item.id,index)">
                                                <span class="unfollow"></span><em>立即关注</em>
                                            </div>

                                            <p class="timeplan">{{item.openingTime}}</p>
                                            <a class="btn-reserve" :href="appointmentImm(item.id)" v-if="item.isBooking=='1'">立即预约</a>
                                            <p class="btn-reserve btn-not-booking" v-else>立即预约</p>

                                        </div>
                                    </div>
                                </template>
                            </div>


                        <div class="no-match" v-if="clinicListData.length==0">
                            <p><i></i>未搜索到符合条件的诊所</p>
                        </div>
                        <Page :total="totalCount" :current="pageNo" :page-size="pageSize" class="list-page"
                              @on-change="changePage" v-if="totalCount"></Page>
                    </div>
                    <div class="list-right" v-if="fitProduct.length > 0">
                        <h1>健康产品</h1>
                        <ul>
                            <template v-for="(item, index) in fitProduct">
                                <li>
                                    <a :href="item.targetUrl">
                                        <div class="pro-img">
                                            <img :src="nginxRoot + item.prdPhoto" alt="" :onerror="defaultErrorImg">
                                        </div>
                                        <div class="pro-name"><p style="overflow: hidden;white-space: nowrap;text-overflow:ellipsis;">{{item.prdName}}</p><span>¥<em> {{parseInt(item.prdPrice)}}</em></span></div>
                                    </a>
                                </li>
                            </template>

                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <FooterBar></FooterBar>
        <MsgDialog></MsgDialog>
        <LoginDialog @on-success="loginSuccessCallBack"></LoginDialog>
    </div>
</template>
<script>
    import PageTopBar from './../Common/pageTopBar';
    import pageHeaderBar from './../Common/pageHeaderBar';
    import SideBar from './../Common/sideBar';
    import FooterBar from './../Common/footerBar'
    import LoginDialog from './../Common/LoginDialog';
    import LoadingBar from './../Utils/loadingBar';
    import MenuBar from './../Common/menuBar';
    import '../../../static/js/utils/scrollLoading';
    import axios from 'axios';
    import MsgDialog from './../Common/msgDialog';
    import url from '../../../config/url';
    import common from '../../../static/js/common'
    import { mapMutations,mapGetters  } from 'vuex'
    export default {
        components:{
            PageTopBar: PageTopBar,
            LoadingBar: LoadingBar,
            SideBar: SideBar,
            pageHeaderBar:pageHeaderBar,
            FooterBar: FooterBar,
            MenuBar: MenuBar,
            MsgDialog: MsgDialog,
            LoginDialog:LoginDialog
        },
        data() {
            return {
                webRoot: url.commonRoot,
                districtList:[],
                departmentsList:[],
                hospitalQualification:[{ //医院资质
                    name: "不限",
                    isSelected: true
                }, {
                    name: "万家认证",
                    code:1
                },{
                    name: "医保",
                    code:2
                },{
                    name: "万家联盟",
                    code:3
                },{
                    name: "商保",
                    code:4
                }],
                totalCount: 0,
                pageSize: 10,
                pageNo: parseInt(this.$route.query.pageNo) || 1,
                searchLoading:true,
                clinicListData:[],
                nginxRoot: window.nginxRoot,
                fitProduct:[],
                defaultClinicImg: 'this.src="https://image.pinganwj.com//web/default/clinic.jpg?resourceVersion=1510238521419"',
                defaultErrorImg: "this.src='"+ url.static +"/img/errorImg.jpg'",
                listShow:false,
                areaShow:false,
                departShow:false
            }
        },
        methods: {
            ...mapMutations([
                'setKeyWord'
            ]),
            initData(){
                this.setKeyWord();
                this.getDistrictList();
                this.getDepartmentsList();
                this.getFitProduct()
//                this.clinicList()
            },
            //选中的样式
            returnClassName(index, isSelected) {
                if (index == 0) {
                    if (isSelected) {
                        return "first-label ivu-checkbox-wrapper  ivu-checkbox-wrapper-checked";
                    } else {
                        return "first-label ivu-checkbox-wrapper";
                    }
                } else {
                    if (isSelected) {
                        return "ivu-checkbox-wrapper  ivu-checkbox-wrapper-checked";
                    } else {
                        return "ivu-checkbox-wrapper";
                    }
                }
            },
            changePage(pageIndex) {
                this.pageNo = pageIndex;
                this.clinicList();
                $('body,html').animate({
                    scrollTop: $('#list-box').offset().top - 10
                }, 0);
                return false;
            },
            appointmentImm(id){
                return window.commonRoot + "/clinic/detail" + "/" + id;
            },
            //区域选择
            getNewDist(index, areaId, isSelected) {
                if (isSelected == "undefined") {
                    isSelected = false;
                }
                //点击不限
                if (index == 0) {
                    if (isSelected) {
                        return
                    } else {
                        this.districtList.forEach((item, i)=> {
                            if (i > 0) {
                                this.districtList[i]["isSelected"] = false;
                            }
                        });
                        this.districtList[0]["isSelected"] = true;
                    }
                } else {
                    if (isSelected) {
                        var len = 0;
                        this.districtList.forEach((item, i) =>{
                            if (i > 0 && item.isSelected) {
                                len++;
                            }
                        });
                        if (len == 1) {
                            this.districtList[0]["isSelected"] = true;
                        }
                        this.districtList[index]["isSelected"] = false;

                    } else {
                        this.districtList[0]["isSelected"] = false;
                        this.districtList[index]["isSelected"] = true;
                    }
                }

                //初始化pageNo
                this.pageNo = 1;
                this.$forceUpdate();
                this.clinicList();
            },
            //科室选择
            getNewDep(index, isSelected) {
                if (isSelected == "undefined") {
                    isSelected = false;
                }
                //点击不限
                if (index == 0) {
                    if (isSelected) {
                        return
                    } else {
                        this.departmentsList.forEach((item, i)=> {
                            if (i > 0) {
                                this.departmentsList[i]["isSelected"] = false;
                            }
                        });
                        this.departmentsList[0]["isSelected"] = true;
                    }
                } else {
                    if (isSelected) {
                        var len = 0;
                        this.departmentsList.forEach((item, i) =>{
                            if (i > 0 && item.isSelected) {
                                len++;
                            }
                        });
                        if (len == 1) {
                            this.departmentsList[0]["isSelected"] = true;
                        }
                        this.departmentsList[index]["isSelected"] = false;

                    } else {
                        this.departmentsList[0]["isSelected"] = false;
                        this.departmentsList[index]["isSelected"] = true;
                    }
                }

                //初始化pageNo

                this.pageNo = 1;
                this.$forceUpdate();
                this.clinicList();
            },
            //医院资质选择
            getNewHospital(index, isSelected) {
                if (isSelected == "undefined") {
                    isSelected = false;
                }
                //点击不限
                if (index == 0) {
                    if (isSelected) {
                        return
                    } else {
                        this.hospitalQualification.forEach((item, i)=> {
                            if (i > 0) {
                                this.hospitalQualification[i]["isSelected"] = false;
                            }
                        });
                        this.hospitalQualification[0]["isSelected"] = true;
                    }
                } else {
                    if (isSelected) {
                        var len = 0;
                        this.hospitalQualification.forEach((item, i) =>{
                            if (i > 0 && item.isSelected) {
                                len++;
                            }
                        });
                        if (len == 1) {
                            this.hospitalQualification[0]["isSelected"] = true;
                        }
                        this.hospitalQualification[index]["isSelected"] = false;

                    } else {
                        this.hospitalQualification[0]["isSelected"] = false;
                        this.hospitalQualification[index]["isSelected"] = true;
                    }
                }

                //初始化pageNo
                this.pageNo = 1;
                this.$forceUpdate();
                this.clinicList();
            },
            //获取区域list
            getDistrictList() {
                let params = {
                    cityCode: window.areaId,
                };
                axios.get(url.districtList, {
                    params: params
                }).then((response)=>{
                    let res = response.data;
                    if (res.status == "SUCCESS") {
                        this.districtList = [
                            {
                                name: "不限",
                                areaId: 0,
                                isSelected: true
                            }
                        ];
                        this.districtList = this.districtList.concat(res.result);
                    }
                }).catch(function () {
                    console.log('数据获取失败,请稍后再试!');
                });
            },
            //科室list
            getDepartmentsList(){
                axios.post(url.department).then(response=>{
                    let res = response.data;
                    if (res.status == "SUCCESS") {
                        //获取url的科室Id 如果存在则标亮 TODO内测一下
                        var deId = '';
                        var path_arr =  window.location.href.split("/");
                        path_arr.forEach(function (item) {
                            if(item.indexOf("DPT") > -1){
                                deId = item;
                            }
                        });

                        if(deId){
                            this.departmentsList = [
                                {
                                    departmentName: "不限",
                                    isSelected: false
                                }
                            ];

                            res.result.forEach((item, index)=> {
                                if (index > 0 && (item.departmentId == deId)) {
                                    res.result[index].isSelected = true;
                                }
                            });

                            this.departmentsList = this.departmentsList.concat(res.result);
                            this.searchLoading = true;
                            this.clinicList();
                            return;
                        }

                        this.departmentsList = [
                            {
                                departmentName: "不限",
                                isSelected: true
                            }
                        ];

                        this.departmentsList = this.departmentsList.concat(res.result);
                        this.clinicList();

                    }
                }).catch(err=>{
                    console.log('数据获取失败,请稍后再试!');
                })
            },
            //根据条件展示列表数据
            clinicList(){
                var dist = [];
                var departments = []
                var qualifications = []
                // 获取选中区域参数;
                this.districtList.forEach((item, index)=> {
                    if (index > 0 && item.isSelected) {
                        dist.push(item.areaId);
                    }
                });

                this.departmentsList.forEach((item, index)=> {
                    if (index > 0 && item.isSelected) {
                        departments.push(item.departmentId);
                    }
                });

                this.hospitalQualification.forEach((item, index)=> {
                    if (index > 0 && item.isSelected) {
                        qualifications.push(item.code);
                    }
                });

                let params = {
                    cityCode: window.areaId,
                    pageSize:this.pageSize,
                    pageNo: this.pageNo,
                    districtCode:dist.join(','),
                    deptIds:departments.join(','),
                    keyWords:this.keyWord,
                    qualifications:qualifications.join(',')
                };



                axios.get(url.clinicPage, {
                    params: params
                }).then((res) =>{
                    if (res.data.status == "SUCCESS" && res.data.result != null && res.data.result.results != null) {
                        this.listShow = true;
                        this.searchLoading = false;
                        this.totalCount = res.data.result.totalCount;
                        this.clinicListData = res.data.result.results;
                    }
                }).catch(()=>{
                    this.searchLoading = false;
                    console.log('数据获取失败,请稍后再试!');
                });
            },
            getFitProduct(){
                var params = {
                    cityCode: window.areaId,
                };
                axios.get(url.getRecomentProduct,{
                    params: params
                }).then( (response)=> {
                    var res = response.data;
                    if(res.status == "SUCCESS"){
                        this.fitProduct = res.result;
                    }
                }).catch( (error)=> {
                    console.log(error, '数据获取失败,请稍后再试!');
                });
            },
            judgeLogin() {
                var userInfo = this.$store.state.userInfo;
                if (userInfo != null && userInfo.userId > 0) {
                    return true;
                } else {
                    //this.$store.commit('changeShowLoginDialogState');
                    window.location.href = url.loginUrl;
                    return false;
                }
            },

            //点击关注按钮
            followFun(id,index){
                var flag = this.judgeLogin();
                if(flag){
                    var params = {
                        clinicId: id,
                    };
                    axios.get(url.insertClinicConcern,{
                        params: params
                    }).then( (response)=> {
                        var res = response.data;
                        if(res.status == "SUCCESS"){
                            this.clinicListData[index].isConcern = '1';
                        }
                    }).catch( (error)=> {
                        this.$Message.error(error, '数据获取失败,请稍后再试!');
                    });
                }
            },
            //取消关注按钮
            unfollowFun(id,index){
                var params = {
                    clinicId: id,
                };
                axios.get(url.deleteClinicConcern,{
                    params: params
                }).then( (response)=> {
                    var res = response.data;
                    if(res.status == "SUCCESS"){
                        this.clinicListData[index].isConcern = false;
                    }
                }).catch( (error)=> {
                    this.$Message.error(error, '数据获取失败,请稍后再试!');
                });
            },

            loginSuccessCallBack() {
                //登陆成功之后的操作
                this.$forceUpdate();
                this.clinicList();
            },
            returnImgPath(path, root, type){
                if(type == "middle"){
                    if(path != null && path.length > 0){
                        return root +"/middle/" +  path
                    }else{
                        return "https://image.pinganwj.com//web/default/clinic.jpg?resourceVersion=1510238521419"
                        //return url.static + '/img/clinicDefault.jpg'
                    }
                }else{
                    if(path != null && path.length > 0){
                        return root +  path
                    }else{
                        return "https://image.pinganwj.com//web/default/clinic.jpg?resourceVersion=1510238521419"
                    }
                }

            },
            areaMore(){
                if(!this.areaShow){
                    this.areaShow = true;
                    $("#clinic-area").css({
                        "height":"auto"
                    });
                    $("#area-triangle").removeClass('triangle-down')
                    $("#area-triangle").addClass('triangle-up')
                }else{
                    this.areaShow = false;
                    $("#clinic-area").css({
                        "height":"55px"
                    });
                    $("#area-triangle").removeClass('triangle-up')
                    $("#area-triangle").addClass('triangle-down')
                }
            },
            departMore(){
                if(!this.departShow){
                    this.departShow = true;
                    $("#clinic-depart").css({
                        "height":"auto"
                    });
                    $("#depart-triangle").removeClass('triangle-down')
                    $("#depart-triangle").addClass('triangle-up')
                }else{
                    this.departShow = false;
                    $("#clinic-depart").css({
                        "height":"55px"
                    });
                    $("#depart-triangle").removeClass('triangle-up')
                    $("#depart-triangle").addClass('triangle-down')
                }
            },
        },
        computed:{
            ...mapGetters(['keyWord'])
        },
        created: function () {
            this.initData();
        },
    }
</script>

<style lang="scss" scoped>
    @import "../../../static/scss/page/listClinic.scss";
</style>
<style lang="scss">
    .list {
        padding-left: 80px;
        position: relative;
        .first-label {
            position: absolute;
            left: 0;
            top: 0;
        }
        .ivu-checkbox {
            display: none;
        }
        .ivu-checkbox-wrapper-checked p {
            color: #fff !important;
            background: #38a3e4;
        }
        .ivu-checkbox + span {
            margin-right: 0;
        }
    }
    .list-page{
        margin: 30px auto;
        li{
            border-radius: 100%;
            height: 40px;
            line-height: 40px;
            min-width: 40px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/Clinic/list.vue